import { render, staticRenderFns } from "./ChatInfoReplyEdit.vue?vue&type=template&id=97f622f4&scoped=true&"
import script from "./ChatInfoReplyEdit.vue?vue&type=script&lang=js&"
export * from "./ChatInfoReplyEdit.vue?vue&type=script&lang=js&"
import style0 from "./ChatInfoReplyEdit.vue?vue&type=style&index=0&id=97f622f4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f622f4",
  null
  
)

export default component.exports